import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import HomeScreen from "../../mobileScreens/homeScreen";
import OrderTypeScreen from "../../mobileScreens/orderTypeScreen";
import UserLogin from "../../mobileScreens/userLogin";
import OrderDetailsScreen from "../../mobileScreens/orderDetailsScreen";
import MyProfileScreen from "../../mobileScreens/myProfileScreen";
import CheckoutScreen from "../../mobileScreens/checkoutScreen";
import TrackOrderScreen from "../../mobileScreens/trackOrderScreen";
import PaymentProcessingMobile from "../../mobileScreens/paymentProcessingMobile";
import TopHeader from "../topHeader";
import PastOrdersScreen from "../../mobileScreens/pastOrdersScreen";
import TermsOfService from "../../mobileScreens/termsOfServiceScreen";
import RiderTrackingScreen from "../../mobileScreens/riderTrackingScreen";
import SubdomainSync from "../../components/subdomainSync";
import { getSubdomainPath } from "../../helpers/pathUtils";

interface IMobileAppProps {};

// Layout component that wraps screens with TopHeader and passes route props
const Layout = ({ children, ...routeProps }: any) => (
  <>
    <TopHeader {...routeProps} />
    {children}
  </>
);

// Route configuration
const mobileRoutes = [
  { path: "/m", component: HomeScreen },
  { path: "/m/area-select", component: OrderTypeScreen },
  { path: "/m/login", component: UserLogin },
  { path: "/m/order-details", component: OrderDetailsScreen },
  { path: "/m/my-profile", component: MyProfileScreen },
  { path: "/m/past-orders", component: PastOrdersScreen },
  { path: "/m/checkout", component: CheckoutScreen },
  { path: "/m/trackorder", component: TrackOrderScreen },
  { path: "/m/rider-tracking", component: RiderTrackingScreen },
  { path: "/m/terms-of-service", component: TermsOfService },
  { path: "/payment-processing", component: PaymentProcessingMobile },
];

const MobileApp = (props: IMobileAppProps) => {
  return (
    <div>
      <SubdomainSync />
      <Switch>
        {mobileRoutes.flatMap((route: any) => [
          <Route key={route.path} exact path={route.path} render={(routeProps) => (
            <Layout {...routeProps}>
              <route.component {...routeProps} />
            </Layout>
          )} />,
          <Route key={`/:subdomain${route.path}`} exact path={`/:subdomain${route.path}`} render={(routeProps) => (
            <Layout {...routeProps}>
              <route.component {...routeProps} />
            </Layout>
          )} />
        ])}
        <Redirect to={getSubdomainPath("/m")} />
      </Switch>
    </div>
  );
};

export default MobileApp;
